module.exports = __webpack_public_path__ + "static/media/face15.736ec0d9.jpg";